import { render, staticRenderFns } from "./merchantsV2.vue?vue&type=template&id=114ed920&"
import script from "./merchantsV2.vue?vue&type=script&lang=js&"
export * from "./merchantsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports